"use strict";module.exports="production"===process.env.NODE_ENV?require("./rematch.min.js"):require("./rematch.js");